// action - account reducer
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const REST_PASSWORD = 'REST_PASSWORD'
export const REGISTER = 'REGISTER'
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const VERIFY_CODE = 'VERIFY_CODE'
